import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { contextApiActions } from "../../../_redux/_constants";
import { Context } from "../../../_context/Store";
import { hideError } from "../../../_redux/_actions/";

export default function UiErrorAlertBox() {
     const [state, dispatch] = useContext(Context);

     const actionDispatch = useDispatch();

     const navigate = useNavigate();

     const { errorMessage } = useSelector((state) => {
          return {
               errorMessage: state.errorMessage,
          };
     });

     // useEffect(() => {
     //      setTimeout(function () {
     //           handleShow(["23243234", "34234234324"]);
     //      }, 7000);
     // }, []);

     useEffect(
          function () {
               if (errorMessage.statusCodes.includes(401)) {
                    navigate("/");
               } else {
                    if (errorMessage.show) {
                         handleShow(errorMessage.messages);
                    }
               }
          },
          [errorMessage],
     );

     const handleCancel = () => {
          dispatch({
               type: contextApiActions.UI_ERROR_MESSAGE_TOGGEL,
               payload: { show: false },
          });

          actionDispatch(hideError());
     };

     const handleShow = (messages) => {
          dispatch({
               type: contextApiActions.UI_ERROR_MESSAGE_TOGGEL,
               payload: { show: true, messages },
          });
     };

     useEffect(
          function () {
               const timeout = setTimeout(() => {
                    handleCancel();
               }, 15000);

               return () => {
                    clearTimeout(timeout);
               };
          },
          [state.uiErrorMessageDetails.show],
     );

     return (
          <>
               {state.uiErrorMessageDetails.show && (
                    <div className="sb-top-error-alert-box">
                         <Alert
                              variant="filled"
                              severity="error"
                              onClose={() => handleCancel()}
                         >
                              {state.uiErrorMessageDetails.messages.map(
                                   (message, index) => (
                                        <p key={index}>{message}</p>
                                   ),
                              )}
                         </Alert>
                    </div>
               )}
          </>
     );
}
